import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

import { DynamicContentBookmark } from "./dynamics";

export const Container = styled.div<ResponsiveStyledProps>`
  justify-content: center;
  align-items: center;

  inline-size: 36px;
  block-size: 36px;

  ${responsiveStyles}
`;

export type BookmarkProps = {
  $variant?: "default" | "magazines-style";
};

export const StyledContentBookmark = styled(DynamicContentBookmark, {
  ...transientOptions,
})<BookmarkProps>`
  inline-size: 100%;
  block-size: 100%;
  padding: 0;

  svg {
    inline-size: 18px;
    block-size: 19px;
  }

  path {
    fill: #000000;
    opacity: 1;
  }

  ${props =>
    props.$variant === "magazines-style" &&
    css`
      path[opacity] {
        fill: #d7d7d7;
        opacity: 1;
      }
    `}
`;
